import { Loading } from 'components/Loading';
import type { LoadingSize } from 'components/Loading/types';

export const getSuspenseFallback = (size: LoadingSize) => (
  <Loading.Center>
    <Loading size={size} />
  </Loading.Center>
);
